export default __webpack_public_path__ + "static/media/15.8b5d8f2b.png";